export default {"src":"/_next/static/media/location.6d0bb380.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};